import { type Messages } from ".";

export const messagesFR: Messages = {
  HOME: {
    TITLE: "Tableau de bord",
    ROUTE: "/dashboard",
    PAGE: "Bienvenue dans DASF",
    INTRO: "Un cadre puissant pour l'évaluation de la gestion des catastrophes",
    SECTION1_TITLE: "Fonctionnalités",
    SECTION1:
      "Cette application soutient l'évaluation des capacités en gestion des catastrophes.",
    SECTION2_TITLE: "Technologie",
    SECTION2: "Construit avec TypeScript et des technologies web modernes.",
    SECTION3_TITLE: "Utilisation",
    SECTION3: "Naviguez dans les sections à l'aide de la barre de navigation.",
  },
  ABOUT: {
    TITLE: "À propos",
    ROUTE: "/about",
    PAGE: "À propos de DASF",
    INTRO: "En savoir plus sur le DIREKTION Assessment & Screening Framework",
    SECTION1_TITLE: "Qu'est-ce que DASF",
    SECTION1:
      "Le DIREKTION Assessment & Screening Framework aide les organisations dans la gestion des catastrophes.",
    SECTION2_TITLE: "Fonctionnalités clés",
    SECTION2:
      "Évaluation des capacités, identification des lacunes, évaluation des solutions et feuille de route.",
    SECTION3_TITLE: "Objectifs de développement",
    SECTION3:
      "Fournir un cadre clair et maintenable pour la gestion des catastrophes.",
  },
  SETTINGS: {
    TITLE: "Paramètres",
    ROUTE: "/settings",
    PAGE: "Paramètres de l'application",
    INTRO: "Configurez vos préférences d'application",
    SECTION1_TITLE: "Préférences linguistiques",
    SECTION1: "Changez de langue parmi les langues disponibles.",
    SECTION2_TITLE: "Paramètres d'affichage",
    SECTION2: "Personnalisez l'apparence visuelle de l'application.",
    SECTION3_TITLE: "Préférences",
    SECTION3: "Gérez le comportement de l'application.",
  },
  LANDING: { TITLE: "Introduction", ROUTE: "/" },
  HAZARDS: { TITLE: "Risques", ROUTE: "/hazards" },
  SOLUTIONS: { TITLE: "Solutions", ROUTE: "/solutions" },
  ROADMAP: { TITLE: "Feuille de route", ROUTE: "/roadmap" },
  USER: "Utilisateur",
  EDITOR: "Éditeur",
  ADMIN: "Administrateur",
  CANCEL: "Annuler",
  DELETE: "Supprimer",
  YES: "Oui",
  NO: "Non",
  OK: "OK",
  NAME: "Nom",
  DESCRIPTION: "Description",
  DELETE_ITEM: {
    TITLE: "Supprimer {item}",
    DESCRIPTION:
      "Êtes-vous certain de vouloir supprimer cet {item} ? Il n'y a pas de retour en arrière.",
  },
  SAVE_BUTTON: {
    LABEL: "Enregistrer",
    TOOLTIP: "Enregistrer les modifications non sauvegardées",
  },
  SEARCH: "Rechercher...",
  SEARCH_TOOLTIP: "Tapez / pour rechercher",
  LANGUAGE: "Langue",
  CLEAR: "Effacer le modèle",
  UPLOAD: "Importer le modèle en JSON",
  DOWNLOAD: "Exporter le modèle en JSON",
  PERMALINK: "Créer un lien permanent",
  ROLE: "Rôle",
  LINK: "Lien",
  MODEL: "Modèle",
  TITLE: "Titre",
  AUTHORS: "Auteurs",
  TYPE: "Type",
  HITS: {
    n: "{n} Résultats",
  },
  NO_RESULTS: "Aucun résultat trouvé",
  CLEAR_SEARCH: "Effacer la recherche",
  PAGE_NOT_FOUND: "Page introuvable",

  about_route: "/about",
  about: "À propos",
  acronym: "Acronyme",
  add_term: "Ajouter un nouveau terme",
  addr_how: "Comment est-il traité ?",
  addressed: "Traité",
  ass_instr: "_Évaluez la contribution d'une capacité à vos objectifs._",
  ass_label: "La cause du problème est bien connue",
  ass_overall: "Besoin d'amélioration",
  ass_scale: "Échelle du score d'évaluation",
  ass_setting: "Matrice d'évaluation",
  ass: "Évaluation",
  assess_content:
    "Déterminez pour chaque capacité son importance et votre performance actuelle.",
  assess: "Évaluer",
  assessment_route: "/assessment/:id",
  assessment: "Évaluation",
  avg_perf: "Évaluation globale",
  cap_cat: "Catégorie de capacité",
  cap: "Capacité",
  caps: "Capacités",
  cat: "Catégorie",
  clear_all: "Effacer tous les filtres",
  clear: "Effacer",
  color: "Couleur",
  create_cap: "Créer une capacité",
  defs: "Définitions",
  del_model: "Voulez-vous vraiment tout supprimer ?",
  del_model_desc: "Êtes-vous sûr de vouloir supprimer votre modèle ?",
  del_proj: "Supprimer le projet",
  desc_cap_instr: "Décrivez la capacité en détail.",
  desc: "Description",
  develop_content: "Commencez à développer vos capacités.",
  develop: "Développer",
  development: "Développement",
  development_route: "/development/:id",
  dev_cap:
    "_Suggérez de nouveaux projets pour développer votre capacité. Commencez par sélectionner une capacité._",
  doc_id: "ID du document",
  doc: "Documentation",
  download: "Télécharger",
  duration: "Durée",
  edit: "Modifier",
  view: "Voir",
  evaluation_route: "/evaluation/:id",
  evaluation: "Évaluation",
  exp_perf: "Performance attendue",
  expl: "Explication",
  expl2: "Performance",
  filter_cap: "Filtrer les capacités",
  filter_caps: "Filtrer les capacités",
  filter_ph: "Titre ou description",
  filter_text_ph: "Terme ou description",
  filter_text: "Texte du filtre",
  filters: "Filtres",
  relevance: "Pertinence",
  gap_scale: "Échelle de la lacune",
  gap_settings: "##### Paramètres des lacunes",
  gap: "Lacune",
  gaps_common: "Lacunes communes ou causes de problèmes",
  gaps: "Lacunes",
  gng: "###### Décision GO / NO GO<br>",
  go: "GO",
  goal_scale: "Échelle pour les thèmes d'évaluation",
  goals_instr: "Spécifier les objectifs à long et court terme",
  goal: "Objectif",
  goals: "Objectifs",
  group_goals_instr:
    "1. **Définissez les objectifs de groupe que vous souhaitez atteindre.**\n2. Spécifiez vos parties prenantes et leurs objectifs organisationnels.\n3. Spécifiez les catégories de capacités pour organiser les capacités.\n4. Spécifiez les capacités nécessaires pour atteindre les objectifs de groupe.",
  group_goals: "Définir les objectifs de groupe",
  home_route: "/",
  home: "ACCUEIL",
  id: "ID",
  importance: "Importance",
  in_months: "En mois",
  loc: "Salle/emplacement",
  main_goals: "Objectifs",
  assess_capability_importance_for_capability:
    'Évaluez l\'importance de "{capability}" pour le périmètre choisi.',
  max_imp: "Contribution maximale",
  name: "Nom",
  no_go: "NO GO",
  no: "Non",
  org_dept: "Organisation / Département",
  overview_route: "/overview",
  overview: "Aperçu",
  level: "Niveau",
  perf_asp: "Aspect de performance",
  perf_asps: "Aspects de performance",
  assess_performance_aspects_for_capability:
    "Évaluez les aspects de performance de {capability}.",
  perf_effectiveness_tooltip:
    "Quel est le niveau d'efficacité de {capability} ?",
  perf_safety_professionals_tooltip:
    "Quel est le niveau de sécurité physique et mentale du personnel opérationnel travaillant sur {capability} ?",
  perf_efficiency_tooltip: "Quel est le niveau d'efficience de {capability} ?",
  perf_scale: "Échelle pour le score de performance",
  perf_settings: "##### Paramètres d'évaluation",
  perf: "Performance",
  period: "AAAA T1 ou AAAA M1",
  permalink: "Lien permanent",
  pers_inv: "Personnes impliquées",
  pick_more: "Choisir un ou plusieurs",
  pick_one: "Choisir un",
  prep_content: "_Définissez les objectifs de votre organisation._",
  preparation_route: "/objectifs",
  preparation: "Objectifs",
  prepare_content: "Créez ou sélectionnez les capacités importantes.",
  prepare: "Préparer",
  prob_areas: "Zones problématiques",
  gap_problem_categories_intro:
    "Analysez cette lacune de capacité selon les catégories de problèmes suivantes.",
  gap_likert_severity: "Gravité",
  gap_likert_severity_start_label: "Très faible",
  gap_likert_severity_middle_label: "Moyen",
  gap_likert_severity_end_label: "Très élevé",
  gap_likert_probability: "Probabilité",
  gap_likert_probability_start_label: "Pas de changement",
  gap_likert_probability_middle_label: "—",
  gap_likert_probability_end_label: "Forte diminution",
  gap_likert_impact: "Impact",
  gap_likert_impact_start_label: "Pas de changement",
  gap_likert_impact_middle_label: "—",
  gap_likert_impact_end_label: "Forte diminution",
  gap_likert_severity_tooltip:
    "Comment évaluez-vous la gravité de cette lacune de capacité ?",
  gap_likert_probability_tooltip:
    "Supposons que la lacune soit résolue : qu'est-ce que cela impliquerait pour la probabilité d'occurrence de la lacune ?",
  gap_likert_impact_tooltip:
    "Supposons que la lacune soit résolue. Qu'est-ce que cela impliquerait pour la réduction de l'impact de la lacune initiale ?",
  prob: "Problème",
  proj_app: "###### PROJET APPROUVÉ<br>",
  proj_name: "Nom du projet",
  proj_prop: "Nouveau projet ou proposition",
  proj_sum: "Résumé du projet",
  prop_name: "Nom de la proposition",
  prop_new: "Nouvelle proposition",
  ref: "Référence",
  ref_url: "URL de référence",
  select_cap: "Sélectionner une capacité",
  select_cat: "Sélectionner une catégorie",
  select_m_ph: "Sélectionner un ou plusieurs",
  select_subcat: "Sélectionner une sous-catégorie",
  settings_route: "/settings",
  settings: "Paramètres",
  sh_filter: "Filtrer les organisations impliquées",
  sh_org: "Organisations parties prenantes",
  sh_settings: "##### Paramètres des parties prenantes",
  sh_type: "Type de partie prenante",
  sh_types: "Types de parties prenantes",
  sh: "Partie prenante",
  shs: "Parties prenantes",
  other_stakeholder: "Veuillez décrire l'autre partie prenante",
  spec_cap_instr:
    "1. Définissez les objectifs de groupe que vous souhaitez atteindre.\n2. Spécifiez vos parties prenantes et leurs objectifs organisationnels.\n3. Spécifiez les catégories de capacités pour organiser les capacités.\n4. **Spécifiez les capacités nécessaires pour atteindre les objectifs de groupe.**",
  spec_cap: "Spécifier les capacités",
  spec_cat_instr:
    "1. Définissez les objectifs de groupe que vous souhaitez atteindre.\n2. Spécifiez vos parties prenantes et leurs objectifs organisationnels.\n3. **Spécifiez les catégories de capacités pour organiser les capacités.**\n4. Spécifiez les capacités nécessaires pour atteindre les objectifs de groupe.",
  spec_cat: "Spécifier les catégories",
  spec_sh_instr:
    "1. Définissez les objectifs de groupe que vous souhaitez atteindre.\n2. **Spécifiez vos parties prenantes et leurs objectifs organisationnels.**\n3. Spécifiez les catégories de capacités pour organiser les capacités.\n4. Spécifiez les capacités nécessaires pour atteindre les objectifs de groupe.",
  spec_sh: "Spécifier les parties prenantes",
  start_time: "Heure de début",
  subcat: "Sous-catégorie",
  task_settings: "##### Paramètres des tâches",
  task: "Tâche",
  task2perf: "##### Tableau de correspondance tâche-performance",
  tasks: "Tâches",
  ass_task_scale: "Échelle des tâches",
  ass_perf_scale: "Performance",
  taxonomy_route: "/taxonomy",
  taxonomy: "Taxonomie",
  tax_def:
    "#### Taxonomie\n\nDéfinitions et abréviations des termes couramment utilisés.",
  TAXONOMY: {
    HAZARD: "Risque",
    HAZARD_DEF:
      "Un processus, phénomène ou activité humaine pouvant causer des pertes en vies humaines, des blessures, des perturbations ou des dommages environnementaux.",
    HAZARD_TYPE: "Type de risque",
    HAZARD_TYPE_DEF:
      "Une classe de risques d'origine ou de caractéristiques similaires, comme les risques naturels, technologiques ou d'origine humaine.",
    DISASTER: "Catastrophe",
    DISASTER_DEF:
      "Une perturbation grave d'une communauté ou d'une société qui dépasse ses capacités à faire face avec ses propres ressources.",
    EMERGENCY: "Urgence",
    EMERGENCY_DEF:
      "Une situation nécessitant une action coordonnée immédiate pour protéger la vie, la santé, les biens ou l'environnement.",
    DISASTER_RISK: "Risque de catastrophe",
    DISASTER_RISK_DEF:
      "Le potentiel de pertes dues à des événements dangereux, déterminé par l'aléa, l'exposition, la vulnérabilité et la capacité.",
    EXPOSURE: "Exposition",
    EXPOSURE_DEF:
      "La présence de personnes, de biens, d'infrastructures et de services dans des zones où des risques peuvent survenir.",
    VULNERABILITY: "Vulnérabilité",
    VULNERABILITY_DEF:
      "Des conditions qui augmentent la susceptibilité des personnes, des biens ou des systèmes aux impacts des risques.",
    CAPACITY: "Capacité",
    CAPACITY_DEF:
      "Les forces et ressources disponibles pour anticiper, faire face, résister et se remettre des impacts des risques.",
    CAPABILITY: "Aptitude",
    CAPABILITY_DEF:
      "Une capacité spécifique et démontrable d'une organisation à effectuer des tâches et à obtenir des résultats dans des conditions définies.",
    RESILIENCE: "Résilience",
    RESILIENCE_DEF:
      "La capacité des systèmes et des communautés à résister, absorber, s'adapter et se remettre tout en préservant les fonctions essentielles.",
    PREVENTION: "Prévention",
    PREVENTION_DEF:
      "Actions pour éviter la création de nouveaux risques et empêcher les risques de causer des impacts néfastes.",
    MITIGATION: "Atténuation",
    MITIGATION_DEF:
      "Mesures réduisant la gravité ou la probabilité des impacts négatifs d'événements dangereux.",
    PREPAREDNESS: "Préparation",
    PREPAREDNESS_DEF:
      "Connaissances, plans et capacités développés à l'avance pour permettre une anticipation, une réponse et une récupération efficaces.",
    EARLY_WARNING_SYSTEM: "Système d'alerte précoce",
    EARLY_WARNING_SYSTEM_DEF:
      "Un système intégré de surveillance des risques, d'évaluation des risques, de communication des alertes et d'action rapide.",
    RESPONSE: "Réponse",
    RESPONSE_DEF:
      "Actions prises juste avant, pendant ou immédiatement après un événement pour sauver des vies et répondre aux besoins urgents.",
    RECOVERY: "Rétablissement",
    RECOVERY_DEF:
      "Le processus de restauration et d'amélioration des moyens de subsistance, des services, des infrastructures et des systèmes après une catastrophe.",
    BUILD_BACK_BETTER: "Reconstruire en mieux",
    BUILD_BACK_BETTER_DEF:
      "Utiliser la récupération et la reconstruction pour réduire les risques futurs et améliorer la résilience au-delà des conditions d'avant la catastrophe.",
    CONTINGENCY_PLANNING: "Planification d'urgence",
    CONTINGENCY_PLANNING_DEF:
      "Préparation de plans opérationnels spécifiques et de modalités de coordination pour des scénarios d'urgence plausibles.",
    RISK_ASSESSMENT: "Évaluation des risques",
    RISK_ASSESSMENT_DEF:
      "Un processus structuré pour identifier les risques, analyser les conséquences et estimer les risques pour soutenir les décisions.",
    RISK_COMMUNICATION: "Communication sur les risques",
    RISK_COMMUNICATION_DEF:
      "Échange bidirectionnel d'informations sur les risques entre les autorités, les intervenants, les parties prenantes et le public.",
    SITUATION_AWARENESS: "Conscience de la situation",
    SITUATION_AWARENESS_DEF:
      "Une compréhension actuelle et partagée des conditions d'incident, des impacts, des ressources et des développements probables.",
    INCIDENT_COMMAND: "Commandement d'incident",
    INCIDENT_COMMAND_DEF:
      "Une structure de commandement et de coordination pour gérer les rôles, les décisions et les ressources lors d'incidents.",
    STAKEHOLDER: "Partie prenante",
    STAKEHOLDER_DEF:
      "Toute organisation, groupe ou individu ayant un rôle, une responsabilité ou un intérêt dans la préparation, la réponse ou la récupération.",
    INTEROPERABILITY: "Interopérabilité",
    INTEROPERABILITY_DEF:
      "La capacité des organisations, des équipes et des systèmes à travailler ensemble efficacement à travers les procédures, les données et la technologie.",
    CAPABILITY_GAP: "Lacune de capacité",
    CAPABILITY_GAP_DEF:
      "La différence entre les niveaux de capacité requis et actuels nécessaires pour atteindre les résultats cibles.",
    CAPABILITY_ASSESSMENT: "Évaluation des capacités",
    CAPABILITY_ASSESSMENT_DEF:
      "Une évaluation structurée de l'importance et de la performance des capacités pour identifier les priorités d'amélioration.",
    SOLUTION: "Solution",
    SOLUTION_DEF:
      "Une mesure, pratique, technologie ou intervention proposée pour combler une ou plusieurs lacunes de capacité.",
    SOLUTION_ASSESSMENT: "Évaluation des solutions",
    SOLUTION_ASSESSMENT_DEF:
      "Une appréciation systématique des solutions candidates par rapport aux besoins des utilisateurs, à l'adéquation opérationnelle, à l'impact et à la conformité.",
    ROADMAP: "Feuille de route",
    ROADMAP_DEF:
      "Un plan de mise en œuvre par phases indiquant ce qui sera livré, par qui et quand.",
    IMPLEMENTATION_TIMELINE: "Calendrier de mise en œuvre",
    IMPLEMENTATION_TIMELINE_DEF:
      "La séquence et le calendrier planifiés des activités, jalons et livrables pour la mise en œuvre.",
    PRIORITIZATION: "Priorisation",
    PRIORITIZATION_DEF:
      "Classement des actions ou investissements en fonction de l'urgence, de l'impact attendu, de la faisabilité et des ressources disponibles.",
    MONITORING_EVALUATION: "Suivi et évaluation",
    MONITORING_EVALUATION_DEF:
      "Suivi continu et révision périodique des progrès, des résultats et de l'efficacité pour soutenir l'apprentissage et l'ajustement.",
    LESSONS_LEARNED: "Leçons apprises",
    LESSONS_LEARNED_DEF:
      "Informations documentées tirées des opérations et exercices pour améliorer la planification et la performance futures.",
    SESSION: "Session d'évaluation",
    SESSION_DEF:
      "Un contexte de travail sauvegardé contenant les risques sélectionnés, les évaluations, les solutions et les données de feuille de route.",
    COMPLIANCE_CHECK: "Vérification de conformité",
    COMPLIANCE_CHECK_DEF:
      "Une vérification que les solutions et actions proposées respectent les exigences légales, politiques, éthiques et sectorielles.",
    TECHNOLOGY_READINESS_LEVEL: "Niveau de maturité technologique",
    TECHNOLOGY_READINESS_LEVEL_DEF:
      "Une échelle de 1 à 9 indiquant la maturité d'une technologie, du concept au déploiement opérationnel.",
  },
  term: "Terme",
  title: "Titre",
  upload: "Importer",
  url: "URL",
  value: "Valeur",
  yes: "Oui",
  TBD: "Inconnu",
  general_settings: "Général",
  enable_sol_ass_support: "Évaluation des solutions activée",
  logo: "Logo utilisateur",
  attribution_logo: "Logo d'attribution",
  attribution_text: "Texte d'attribution",
  order: "Ordre",
  hide: "Masquer dans la vue d'ensemble",
  select_user: "Sélectionner un utilisateur",
  user: "Utilisateur standard",
  moderator: "Modérateur",
  admin: "Administrateur",
  doc_title: "Rapport d'évaluation des capacités",
  export_to_word: "Exporter en Word",
  export_all_to_word: "Exporter le rapport complet en Word",
  add_gap: "Ajouter une lacune de capacité",
  ignore: "Non applicable",
  continue: "Continuer",
  hazards: "Risques",
  hazards_route: "/hazards",
  hazard_step_title: "Étape 0 : Initiation & Préparation",
  hazard_step_desc:
    "Sélectionnez les types de risques pertinents pour le périmètre que vous souhaitez aborder dans cet atelier d'évaluation.",
  workshop_scope: "Périmètre de l'atelier",
  hazard_category_all: "Tous",
  hazard_category_natural: "Naturel",
  hazard_category_technical: "Technique",
  hazard_category_attack: "Attaque",
  hazard_edit: "Modifier les types de risques",
  hazard_done: "Terminer l'édition",
  hazard_add: "Ajouter un nouveau type de risque",
  hazard_name: "Nom du risque",
  hazard_description: "Description / contexte",
  hazard_selected_count: "{n} type(s) de risque sélectionné(s).",
  solutions: "Solutions",
  solution_count: {
    1: "1 solution",
    n: "{n} solutions",
  },
  solutions_route: "/solutions",
  solutions_step_title: "Étape 2 : Évaluation des solutions",
  solutions_step_desc:
    "Ajouter et évaluer des solutions pour les lacunes identifiées.",
  solution_add: "Ajouter une solution",
  solution_new: "Nouvelle solution",
  solution_gaps_found: {
    1: "1 lacune de capacité identifiée",
    n: "{n} lacunes de capacités identifiées",
  },
  solution_empty:
    "Aucune solution ajoutée pour l'instant. Cliquez sur 'Ajouter une solution' pour commencer.",
  roadmap: "Feuille de route",
  roadmap_count: {
    1: "1 élément de feuille de route",
    n: "{n} éléments de feuille de route",
  },
  roadmap_route: "/roadmap",
  roadmap_step_title: "Étape 3 : Feuille de route",
  roadmap_step_desc:
    "Planifier les calendriers de mise en œuvre et les engagements.",
  roadmap_add_solutions: "Ajouter {n} solution(s) à la feuille de route",
  roadmap_empty_solutions:
    "Complétez d'abord l'étape 2 (Évaluation des solutions) pour ajouter des solutions à la feuille de route.",
  roadmap_empty: "Aucun élément dans la feuille de route.",
  roadmap_timeline: "Calendrier",
  session_create: "Créer",
  session_new_name: "Nom de la nouvelle session",
  session_sessions: "Sessions d'évaluation",
  session_name: "Nom",
  session_updated: "Dernière mise à jour",
  session_actions: "Actions",
  session_clone: "Cloner la session",
  session_download: "Télécharger en JSON",
  session_delete: "Supprimer la session",
  session_import: "Importer JSON",
  session_delete_confirm: "Supprimer la session : {name} ?",
  session_delete_warning: "Cette action est irréversible. Êtes-vous sûr ?",
  dashboard_subtitle:
    "Suivez les étapes ci-dessous pour compléter votre évaluation de gestion des catastrophes.",
  back_to_sessions: "Retour aux sessions",
  step0_title: "Initiation & Préparation",
  step1_title: "Évaluation des besoins & lacunes",
  step2_title: "Évaluation des solutions",
  step3_title: "Feuille de route",
  summary: "Résumé",
  selected_hazards: "Risques sélectionnés",
  capability_gaps: "Lacunes de capacités",
  more: "plus",
  partially: "Partiellement",
  not_assessed: "Non évalué",
  enabled_steps: "Étapes activées",
  priority_low: "Faible",
  priority_medium: "Moyen",
  priority_high: "Élevé",
  sol_trl: "Niveau de maturité technologique",
  trl1: "Principes de base observés",
  trl2: "Concept technologique formulé",
  trl3: "Preuve de concept expérimentale",
  trl4: "Technologie validée en laboratoire",
  trl5: "Technologie validée en environnement pertinent",
  trl6: "Technologie démontrée en environnement pertinent",
  trl7: "Prototype de système démontré en environnement opérationnel",
  trl8: "Système complet et qualifié",
  trl9: "Système réel prouvé en environnement opérationnel",
  sol_integration_rl: "Niveau de préparation à l'intégration",
  sol_societal_rl: "Niveau de préparation sociétale",
  sol_manufacturing_rl: "Niveau de préparation à la fabrication",
  sol_commercialisation_rl: "Niveau de préparation à la commercialisation",
  sol_security_rl: "Niveau de préparation à la sécurité",
  sol_legal_privacy_ethical_rl:
    "Niveau de préparation juridique, vie privée et éthique",
  integration_rl1: "Un concept d'intégration de haut niveau a été identifié",
  integration_rl2:
    "Un certain niveau de spécification des exigences pour l'interaction des composants a été défini",
  integration_rl3:
    "La conception détaillée de l'intégration a été définie afin d'inclure tous les détails d'interface",
  integration_rl4:
    "Validation des fonctions des composants intégrés dans un environnement de laboratoire",
  integration_rl5:
    "Validation des composants intégrés dans un environnement pertinent",
  integration_rl6:
    "Validation des composants intégrés dans un environnement de bout en bout pertinent",
  integration_rl7:
    "Démonstration d'intégration de prototype dans un environnement opérationnel à haute fidélité",
  integration_rl8: "Essai et démonstration dans un environnement opérationnel",
  integration_rl9:
    "Intégration système démontrée par des capacités de mission opérationnelle réussies",
  societal_rl1:
    "Identification du besoin sociétal générique, du bien social et des aspects associés",
  societal_rl2:
    "Formulation du concept de solution proposé et des impacts potentiels",
  societal_rl3:
    "Un groupe limité de la société connaît la solution ou des initiatives similaires",
  societal_rl4:
    "Un groupe limité de la société teste la solution ou des initiatives similaires",
  societal_rl5:
    "La société connaît la solution ou des initiatives similaires mais n'est pas consciente de leurs avantages",
  societal_rl6:
    "La société connaît la solution et la sensibilisation à ses avantages augmente",
  societal_rl7:
    "La société est pleinement consciente des avantages de la solution",
  societal_rl8:
    "La société est prête à adopter la solution et a utilisé des solutions similaires sur le marché",
  societal_rl9:
    "La société utilise la solution et celle-ci est soutenue par les parties prenantes et le public",
  manufacturing_rl1: "Implications de fabrication de base identifiées",
  manufacturing_rl2: "Concepts de fabrication identifiés",
  manufacturing_rl3: "Preuve de concept de fabrication développée",
  manufacturing_rl4:
    "Capacité à produire la technologie dans un environnement de laboratoire",
  manufacturing_rl5:
    "Capacité à produire les composants prototypes dans un environnement de production pertinent",
  manufacturing_rl6:
    "Capacité à produire un prototype de système ou de sous-système dans un environnement de production pertinent",
  manufacturing_rl7:
    "Capacité à produire des systèmes, sous-systèmes ou composants dans un environnement représentatif de la production",
  manufacturing_rl8:
    "Capacité de ligne pilote démontrée. Prêt à commencer une production à faible cadence",
  manufacturing_rl9:
    "Production à faible cadence démontrée. Capacité en place pour commencer une production à cadence complète",
  commercialisation_rl1: "Recherche et hypothèse de base",
  commercialisation_rl2: "Évaluation du marché",
  commercialisation_rl3:
    "Validation de l'application technologique et du marché",
  commercialisation_rl4: "Proposition de valeur",
  commercialisation_rl5:
    "Développement du produit et alignement avec le marché",
  commercialisation_rl6:
    "Optimisation du produit/de la solution et protection de la propriété intellectuelle",
  commercialisation_rl7: "Validation technique et commerciale",
  commercialisation_rl8:
    "Stratégie de commercialisation et introduction sur le marché",
  commercialisation_rl9: "Lancement complet et revenus de licences",
  security_rl1: "Considération de sécurité",
  security_rl2: "Développement du concept de sécurité",
  security_rl3: "Sécurité dès la conception",
  security_rl4: "Préparation des mesures et fonctionnalités de sécurité",
  security_rl5: "Validation simple de la sécurité",
  security_rl6: "Démonstration séquentielle de la sécurité",
  security_rl7: "Démonstrations complexes de sécurité",
  security_rl8:
    "Validation finale de la sécurité avant publication et préparation",
  security_rl9: "Sécurité opérationnelle initiale",
  security_rl10: "Sécurité bien établie/fiable",
  legal_privacy_ethical_rl1:
    "Maîtrise des questions juridiques, éthiques et de protection de la vie privée : le système a mis en œuvre des mécanismes de contrôle de la responsabilité et a passé les références standard et obtenu une certification, le cas échéant",
  legal_privacy_ethical_rl2:
    "Tensions éthiques traitées via l'éthique dès la conception : les considérations juridiques, éthiques et de protection de la vie privée du système ont été conçues pour être compatibles entre elles. Les tensions éthiques ont été traitées de sorte que l'amélioration d'un aspect n'affecte pas négativement un autre aspect",
  legal_privacy_ethical_rl3:
    "Interactions juridiques, éthiques et de protection de la vie privée caractérisées : les interactions entre les différentes considérations éthiques et de protection de la vie privée ont été caractérisées",
  legal_privacy_ethical_rl4:
    "Questions juridiques, éthiques et de protection de la vie privée identifiées : les considérations éthiques et de protection de la vie privée soulevées par le système ont été identifiées et anticipées",
  sol_linked_caps: "Capacités liées (avec lacunes)",
  sol_addressed_gaps: "Lacunes de capacités traitées",
  sol_no_gaps:
    "Aucune lacune de capacité n'a encore été identifiée. Allez à l'étape 1 pour évaluer les capacités.",
  sol_compliance_title: "Vérifications de conformité",
  sol_status: "Statut",
  sol_pass: "Conforme",
  sol_partial: "Partiel",
  sol_fail: "Non conforme",
  sol_na: "N/A",
  sol_not_applicable: "Non applicable",
  sol_user_needs_title: "Évaluation des besoins des utilisateurs",
  sol_operational_needs_title: "Évaluation des besoins opérationnels",
  sol_organisational_needs_title: "Évaluation des besoins organisationnels",
  sol_expected_impact_title: "Évaluation de l'impact attendu",
  sol_question: "Question",
  sol_response: "Réponse",
  UN01: "La solution est-elle facile à utiliser ?",
  UN02: "La solution fonctionnera-t-elle probablement correctement sous pression ? Y compris la robustesse et la fiabilité.",
  UN03: "La solution sera-t-elle probablement acceptée par les utilisateurs ?",
  UN04: "La solution favorisera-t-elle probablement la compréhension des utilisateurs ?",
  UN05: "La solution facilitera-t-elle probablement l'explicabilité pour les utilisateurs ?",
  UN06: "La solution améliorera-t-elle probablement l'efficacité des utilisateurs ?",
  UN07: "La solution améliorera-t-elle probablement l'efficacité des utilisateurs ?",
  UN08: "La solution fournira-t-elle probablement des connaissances supplémentaires ?",
  UN09: "La solution produira-t-elle probablement des interventions et/ou des résultats positifs de manière cohérente ?",
  ON01: "La solution nécessitera-t-elle probablement une (re-)formation extensive ?",
  ON02: "La solution nécessitera-t-elle probablement une maintenance et un soutien excessifs ?",
  ON03: "La solution sera-t-elle probablement compatible avec vos méthodes de travail/POS ?",
  ON04: "La solution est-elle interopérable ?",
  ON05: "La solution sera-t-elle probablement adaptable et transférable dans vos scénarios opérationnels ?",
  ON06: "La solution soutiendra-t-elle probablement la santé et la sécurité des intervenants ?",
  ON07: "La solution atteindra-t-elle probablement la population cible visée ?",
  ON08: "La solution offrira-t-elle probablement une meilleure efficacité opérationnelle ?",
  ON09: "La solution offrira-t-elle probablement une meilleure efficacité opérationnelle ?",
  OG01: "La solution aura-t-elle probablement un bilan coût-bénéfice positif ?",
  OG02: "La solution semble-t-elle faisable ? Sur le plan technologique, économique, juridique, opérationnel et calendaire.",
  OG03: "La solution sera-t-elle probablement compatible avec votre culture organisationnelle ?",
  OG04: "La solution sera-t-elle probablement compatible avec le mandat de votre organisation ?",
  OG05: "La solution sera-t-elle probablement compatible avec les priorités de la gouvernance de la gestion de crise ?",
  OG06: "L'utilisation de la solution soutiendra-t-elle votre réputation auprès du public ?",
  OG07: "L'utilisation de la solution contribuera-t-elle à améliorer les relations avec la communauté ?",
  EI01: "La solution sera-t-elle appliquée dans le contexte des soins de santé humains ?",
  EI02: "La solution implique-t-elle le traitement de données personnelles ?",
  EI03: "La solution aura-t-elle probablement un impact négatif sur les droits et libertés des individus et des groupes ? Par ex. vie privée, dignité, autonomie, solidarité.",
  EI04: "La solution aura-t-elle probablement un impact négatif en termes de justice sociale et d'égalité ?",
  EI05: "La solution aura-t-elle probablement un impact négatif sur le bien-être des individus ou des groupes ?",
  EI06: "La solution augmentera-t-elle probablement la vulnérabilité des individus ou des groupes ?",
  EI07: "La solution posera-t-elle probablement des risques potentiels pour la sécurité ?",
  EI08: "La solution aura-t-elle probablement un impact négatif sur l'environnement ?",
  EI09: "Existe-t-il une INCERTITUDE SIGNIFICATIVE concernant les impacts juridiques, éthiques et sociétaux de l'utilisation de la solution ?",
  CC01: "Sécurité (cyber)",
  CC02: "Interopérabilité",
  CC03: "Règlement sur l'IA",
  CC04: "Engagement communautaire",
  CC05: "RGPD",
  CC06: "Droits fondamentaux",
  CC07: "Objectifs de développement durable",
  CC08: "Priorités nationales de gestion de crise",
  CC09: "Normes sectorielles spécifiques",
  CC10: "Lois et réglementations sectorielles spécifiques",
  cap_add_from_ref: "Ajouter des capacités depuis la référence",
  cap_all_selected:
    "Toutes les capacités de référence ont été ajoutées à votre session.",
  cap_add_selected: "Ajouter les capacités sélectionnées",
  cap_ref_panel_title: "Capacités disponibles (modèle de référence DASF)",
  collapse: "Réduire",
  step0_abbr: "Étape 0 : I&P",
  step0_desc:
    "Identifier les types de risques pertinents pour votre contexte d'évaluation.",
  step1_abbr: "Étape 1 : EBL",
  step1_desc:
    "Évaluer les capacités, identifier les lacunes et les besoins d'amélioration.",
  step2_abbr: "Étape 2 : ES",
  step2_desc:
    "Évaluer les solutions pour les lacunes de capacités identifiées.",
  step3_abbr: "Étape 3 : FR",
  step3_desc: "Planifier la feuille de route de mise en œuvre.",
  landing_attribution:
    "DIREKTION a reçu des financements du programme de recherche et d'innovation Horizon Europe de l'Union européenne dans le cadre de la convention de subvention n° 101121249.",
  landing_developed_by: "Développé par",
  landing_as_part_of: "dans le cadre du",
  landing_project: "projet.",
  dasf_purpose_title: "Objectif du DASF",
  dasf_purpose_p1:
    "Le DIREKTION Assessment and Screening Framework (DASF) est une méthode centrale développée dans le cadre du projet DIREKTION pour soutenir un processus de sélection et d'évaluation transparent et impartial.",
  dasf_purpose_offers:
    "Le framework DASF propose une méthode étape par étape pour :",
  dasf_purpose_item1:
    "Identifier et combler les lacunes en matière de capacités",
  dasf_purpose_item2:
    "Mettre en œuvre une sélection systématique des technologies et des solutions",
  dasf_purpose_item3: "Établir une feuille de route",
  dasf_purpose_p2:
    "Le DASF fournit la base d'un processus durable de programmation de la recherche, garantissant que les intervenants et les parties prenantes ont accès aux outils les plus efficaces et les plus récents pour la préparation aux catastrophes et la réponse à celles-ci. L'ensemble complet est conçu pour être exécuté régulièrement — par exemple, une fois par an ou une fois tous les quatre ans — afin d'obtenir une vision actualisée des besoins en capacités les plus récents, des lacunes en matière de capacités, des solutions potentielles et de mettre régulièrement à jour la feuille de route pour les opportunités de recherche de l'UE ou nationales.",
  landing_assessment_process: "Processus d'évaluation",
  landing_video_tutorial: "Regarder le tutoriel vidéo sur YouTube",
  landing_funded_by: "Financé par l'Union européenne",
  landing_trilateral_attribution:
    "Pour la création de cet outil, des contributions essentielles de Trilateral Research, telles que développées dans le cadre de DIREKTION D1.2, ont été utilisées.",
  delete_session_confirm: "Supprimer la session : {name} ?",
  delete_session_warning: "Cette action est irréversible. Êtes-vous sûr ?",
  N01: "Séisme",
  N02: "Tsunami",
  N03: "Éruption volcanique",
  N04: "Glissement de terrain / Avalanche",
  N05: "Inondation",
  N06: "Crue soudaine",
  N07: "Tempête / Ouragan / Tornade",
  N08: "Feu de forêt / Incendie naturel",
  N09: "Température extrême (chaleur/froid)",
  N10: "Sécheresse",
  N11: "Épidémie / Pandémie",
  N12: "Épizootie",
  N13: "Infestation d'insectes",
  T01: "Accident industriel (NRBC)",
  T02: "Incident nucléaire / Radiologique",
  T03: "Accident de transport (aérien)",
  T04: "Accident de transport (ferroviaire)",
  T05: "Accident de transport (routier)",
  T06: "Accident de transport (maritime)",
  T07: "Pipeline / Explosion de gaz",
  T08: "Effondrement de bâtiment / structure",
  T09: "Rupture de barrage / digue",
  T10: "Panne d'électricité / Défaillance du réseau",
  T11: "Défaillance des télécommunications",
  T12: "Contamination de l'eau potable",
  T13: "Déversement de matières dangereuses",
  A01: "Attentat terroriste (explosif)",
  A02: "Attentat terroriste (NRBC)",
  A03: "Cyberattaque",
  A04: "Tireur actif / Agression armée",
  A05: "Sabotage d'infrastructures critiques",
  A06: "Prise d'otages / Enlèvement",
  A07: "Troubles civils / Émeutes",
  A08: "Piraterie maritime / Détournement",
  A09: "Attaque de drone",
  A10: "Menace hybride",
  A11: "Campagne de désinformation",
  A12: "Perturbation de la chaîne d'approvisionnement (intentionnelle)",
  A13: "Incendie criminel",
  "Cat-01": "Atténuation / Prévention",
  "Cat-02": "Préparation",
  "Cat-03": "Réponse",
  "Cat-04": "Rétablissement",
  "Mit-01": "Évaluation des risques",
  "Mit-02": "Réduction de l'exposition",
  "Mit-03": "Soutien à l'atténuation",
  "Prep-01": "Développement des capacités",
  "Prep-02": "Surveillance",
  "Prep-03": "Soutien à la préparation",
  "Rsp-01": "Suppression de l'incident",
  "Rsp-02": "Opérations de secours",
  "Rsp-03": "Sécurité / Application de la loi",
  "Rsp-04": "Soins de santé d'urgence",
  "Rsp-05": "Communication vers la société",
  "Rsp-06": "Protection de la population / des animaux",
  "Rsp-07": "Dégagement de la zone sinistrée",
  "Rsp-08": "Approvisionnement en besoins de base",
  "Rsp-09": "Soutien à la réponse",
  "Rec-01": "Rétablissement humanitaire",
  "Rec-02": "Rétablissement environnemental",
  "Rec-03": "Rétablissement économique",
  "Rec-04": "Rétablissement des infrastructures",
  "Rec-05": "Soutien au rétablissement",
  "Mit-RA-01": "Identification des risques",
  "Mit-RA-02": "Analyse des risques",
  "Mit-RA-03": "Évaluation des risques",
  "Mit-ER-01": "Protection des biens",
  "Mit-ER-02": "Protection des ressources naturelles",
  "Mit-ER-03": "Sensibilisation",
  "Mit-MS-01": "Analyse des tendances",
  "Mit-MS-02": "Surveillance et révision",
  "Prep-CD-01": "Planification de la réponse et du rétablissement",
  "Prep-CD-02": "Formation",
  "Prep-CD-03": "Communication sur les risques",
  "Prep-MO-01": "Détection",
  "Prep-MO-02": "Alerte",
  "Prep-PS-01": "Gestion du personnel",
  "Prep-PS-02": "Gestion des actifs",
  "Prep-PS-03": "Établissement de la coopération",
  "Prep-EH-04": "Soins psychologiques",
  "Resp-SI-01": "Lutte contre l'incendie - Infrastructures",
  "Resp-SI-02": "Lutte contre l'incendie - Nature",
  "Resp-SI-03": "Contrôle des inondations",
  "Resp-SI04": "Contrôle des matières dangereuses (NRBC-E)",
  "Resp-RO-01": "Recherche et Sauvetage (SAR)",
  "Resp-RO-02": "Traitement des victimes sur site",
  "Resp-RO-03": "Transport des victimes",
  "Resp-SL-01": "Sécurisation des lieux / personnes",
  "Resp-SL-02": "Identification des personnes",
  "Resp-SL-03": "Médecine légale",
  "Resp-SL-04": "Maintien de l'ordre public",
  "Resp-SL-05": "Gestion de la circulation",
  "Resp-EH-01": "Soins urgents - Hôpitaux",
  "Resp-EH-02": "Quarantaine",
  "Resp-EH-03": "Santé publique de masse",
  "Resp-CS-01": "Alerte",
  "Resp-CS-02": "Communication de crise",
  "Resp-SF-01": "Évacuation",
  "Resp-SF-02": "Hébergement",
  "Resp-SF-03": "Réunification",
  "Resp-DA-01": "Déblaiement",
  "Resp-DA-02": "Décontamination des objets",
  "Resp-DA-03": "Drainage",
  "Resp-DA-04": "Destruction d'animaux",
  "Resp-BN-01": "Approvisionnement en eau potable",
  "Resp-BN-02": "Approvisionnement alimentaire",
  "Resp-BN-03": "Approvisionnement en énergie",
  "Resp-BN-04": "Fourniture de TIC / Télécommunications",
  "Resp-BN-05": "Assainissement",
  "Resp-RS-01": "Commandement, contrôle et coordination",
  "Resp-RS-02": "Évaluation de la situation",
  "Resp-RS-03": "Gestion de l'information",
  "Resp-RS-04": "Surveillance / Collecte de données",
  "Resp-RS-05": "Soutien aux opérations sur site",
  "Resp-RS-06": "Logistique",
  "Rec-HR-01": "Santé publique et sécurité",
  "Rec-HR-02": "Alimentation et hébergement",
  "Rec-ER-01": "Gestion des déchets",
  "Rec-ER-02": "Restauration des habitats",
  "Rec-EC-01": "Rétablissement des entreprises",
  "Rec-EC-02": "Rétablissement financier",
  "Rec-RI-01": "Rétablissement des transports",
  "Rec-RI-02": "Rétablissement des services publics",
  "Rec-RS-01": "Établissement de l'organisation de rétablissement",
  "Rec-RS-02": "Programmation du rétablissement",
  "Goal-01": "Prévenir les incidents",
  "Goal-01_desc": "Prévenir les catastrophes / situations de crise.",
  "Goal-02": "Minimiser les pertes dues aux risques",
  "Goal-02_desc": "Réduire / éviter les pertes dues aux risques.",
  "Goal-03": "Aider les victimes",
  "Goal-03_desc": "Assurer une assistance rapide et efficace aux victimes.",
  "Goal-04": "Rétablissement adéquat",
  "Goal-04_desc": "Assurer un rétablissement rapide et efficace.",
  "TO-01": "Pompiers / Protection civile",
  "TO-02": "Police",
  "TO-03": "Soins de santé d'urgence",
  "TO-04": "Défense",
  "TO-05": "Centre de commandement",
  "TO-06": "Autorités",
  "TO-07": "Infrastructures critiques",
  "TO-08": "ONG",
  "TO-09": "Autres",
  "SH-01": "Pompiers/Protection civile",
  "SH-02": "Police",
  "SH-03": "Soins de santé d'urgence",
  "SH-04": "SAR",
  "SH-05": "Centre de commandement ou de dispatch (112)",
  "SH-06": "Autorités (ministères, municipalités)",
  "SH-07": "Défense",
  "SH-08": "Services publics",
  "SH-09": "Garde côtière ou Sécurité des frontières",
  "SH-10": "Opérateur d'infrastructures critiques",
  "SH-11": "ONG",
  "SH-12": "Autres (à décrire)",
  "Imp-1": "Aucune/Très faible",
  "Imp-2": "Faible",
  "Imp-3": "Moyenne",
  "Imp-4": "Assez élevée",
  "Imp-5": "Très élevée",
  "PA-1": "Efficacité",
  "PA-1_desc": "Qualité des résultats, ponctualité, endurance.",
  "PA-2": "Sécurité/Sûreté des professionnels",
  "PA-2_desc": "Sécurité physique et mentale du personnel impliqué.",
  "PA-3": "Efficience",
  "PA-3_desc": "Rapport entre coûts et résultats.",
  "PSc-1": "Médiocre",
  "PSc-2": "Insuffisant",
  "PSc-3": "Modéré",
  "PSc-4": "Satisfaisant",
  "PSc-5": "Bon",
  "Nat-01": "Technologique",
  "Nat-01_desc":
    "Ex. Technologies de détection, commandement et contrôle, communications et coordination, TIC.",
  "Nat-02": "Humain",
  "Nat-02_desc":
    "Ex. Nombre de personnel, compétence du personnel, formation et éducation.",
  "Nat-03": "Organisationnel",
  "Nat-03_desc":
    "Ex. Procédures, structure organisationnelle, aspects financiers, accords.",
  "Nat-04": "Réglementaire",
  "Nat-04_desc": "Ex. Aspects juridiques, aspects formels de normalisation.",
  "Kn-01": "Inconnu",
  "Kn-02": "Non",
  "Kn-03": "Oui",
  "ASc-01": "Très faible",
  "ASc-02": "Faible",
  "ASc-03": "Modéré",
  "ASc-04": "Élevé",
  "ASc-05": "Très élevé",
  "Cat-01_desc":
    "Objectif : Prendre des mesures pour limiter la probabilité et réduire l'impact d'un incident, d'une catastrophe ou d'une crise.",
  "Cat-02_desc":
    "Objectif : Développer et maintenir la structure organisationnelle et les capacités pour mener des activités de réponse et de rétablissement.",
  "Cat-03_desc": "Objectif : Sauver des vies et limiter les effets négatifs.",
  "Cat-04_desc":
    "Objectif : Reconstruire et restaurer la vie normale de manière efficace.",
  "Mit-01_desc": "Identification, analyse et évaluation des risques.",
  "Mit-02_desc":
    "Protection des biens, des ressources naturelles et de la société en général contre les risques.",
  "Mit-03_desc": "Capacités en soutien à l'atténuation / prévention.",
  "Prep-01_desc":
    "Processus de développement et de maintien des capacités de gestion de crise requises.",
  "Prep-02_desc":
    "Déterminer l'état d'un environnement ou d'une situation pour permettre la détection d'incidents.",
  "Prep-03_desc": "Capacités en soutien au développement des capacités.",
  "Rsp-01_desc":
    "Activités sur site pour arrêter ou contenir la cause de la catastrophe.",
  "Rsp-02_desc": "Activités sur site pour sauver des vies.",
  "Rsp-03_desc":
    "Sécurisation des zones/personnes, identification des personnes, médecine légale.",
  "Rsp-04_desc": "Activités hors site pour sauver des vies.",
  "Rsp-05_desc": "Alerte et communication de crise.",
  "Rsp-06_desc": "Évacuation contrôlée des personnes et/ou animaux.",
  "Rsp-07_desc":
    "Assurer l'accessibilité et la sécurité dans la zone sinistrée.",
  "Rsp-08_desc":
    "Fourniture et/ou rétablissement des produits de base et services essentiels.",
  "Rsp-09_desc":
    "Capacités permettant une ou plusieurs autres capacités de réponse.",
  "Rec-01_desc":
    "Fourniture de services de santé publique, de sécurité et d'hébergement.",
  "Rec-02_desc": "Dépollution et décontamination.",
  "Rec-03_desc": "Rétablissement économique et des entreprises.",
  "Rec-04_desc":
    "Restauration des voies de transport et des services essentiels.",
  "Rec-05_desc": "Capacités nécessaires à un rétablissement bien coordonné.",
  "Mit-RA-01_desc":
    "Processus de recherche, de reconnaissance et de description des risques.",
  "Mit-RA-02_desc":
    "Processus pour comprendre la nature du risque et déterminer le niveau de risque.",
  "Mit-RA-03_desc":
    "Processus de comparaison des résultats de l'analyse des risques avec des critères de risque pour déterminer si le risque est acceptable ou tolérable.",
  "Mit-ER-01_desc":
    "Protection des biens (y compris les infrastructures critiques).",
  "Mit-ER-02_desc":
    "Actions minimisant les pertes dues aux risques et préservant ou restaurant les fonctions des systèmes naturels.",
  "Mit-ER-03_desc":
    "Éducation et sensibilisation du public aux risques et aux moyens potentiels de les atténuer.",
  "Mit-MS-01_desc": "Investigation de l'évolution des risques.",
  "Mit-MS-02_desc":
    "S'assurer que les contrôles sont efficaces et efficients, obtenir des informations supplémentaires pour améliorer l'évaluation des risques.",
  "Prep-CD-01_desc":
    "Développer, compiler et maintenir des procédures et informations prêtes à être utilisées lors d'un incident.",
  "Prep-CD-02_desc":
    "Activités pour faciliter l'apprentissage et le développement des connaissances, compétences et aptitudes pour la réponse aux catastrophes.",
  "Prep-CD-03_desc":
    "Communiquer et instruire le public sur la façon d'être bien préparé à une crise et comment se comporter lorsqu'elle survient.",
  "Prep-MO-01_desc": "Détection de circonstances s'écartant de la normale.",
  "Prep-MO-02_desc":
    "Alerter le personnel de la présence d'un incident et permettre l'initiation d'actions de contrôle.",
  "Prep-PS-01_desc":
    "Activités pour fournir suffisamment de personnel qualifié pour effectuer les tâches de réponse et de rétablissement.",
  "Prep-PS-02_desc":
    "Activités pour fournir l'équipement, les outils, les TIC et autres actifs nécessaires à la réponse et au rétablissement.",
  "Prep-PS-03_desc":
    "Établissement de coopération internationale entre services d'urgence et tiers.",
  "Prep-EH-04_desc":
    "Soins de santé psychologique aux victimes, proches et autres personnes affectées par l'incident.",
  "Resp-SI-01_desc":
    "Lutte contre les incendies dans les bâtiments, zones urbanisées ou infrastructures.",
  "Resp-SI-02_desc": "Lutte contre les incendies en milieu naturel.",
  "Resp-SI-03_desc":
    "Gestion de l'eau en cas d'inondation due à une rupture de digue ou à de fortes pluies.",
  "Resp-SI04_desc":
    "Arrêt du déversement de matières dangereuses, y compris le confinement (incidents NRBC-E).",
  "Resp-RO-01_desc": "Opérations de recherche et sauvetage.",
  "Resp-RO-02_desc": "Triage, décontamination et stabilisation des victimes.",
  "Resp-RO-03_desc":
    "Transport en ambulance vers des zones sûres ou des hôpitaux.",
  "Resp-SL-01_desc":
    "Protéger les zones, infrastructures et personnes des parties non impliquées.",
  "Resp-SL-02_desc": "Identification des victimes.",
  "Resp-SL-03_desc":
    "Activités médico-légales pour enquêter sur la cause de l'incident et préserver les preuves.",
  "Resp-SL-04_desc": "Contrôle des émeutes, etc.",
  "Resp-SL-05_desc":
    "Contrôle de la circulation entrante et sortante de la zone sinistrée.",
  "Resp-EH-01_desc":
    "Service de santé dans des hôpitaux réguliers et/ou de campagne.",
  "Resp-EH-02_desc":
    "Isolement des personnes/victimes potentiellement infectieuses.",
  "Resp-EH-03_desc":
    "Prophylaxie de masse ou vaccination en cas d'incident nucléaire ou de pandémie.",
  "Resp-CS-01_desc":
    "Alerter la société dans la zone menacée en fournissant des informations opportunes et adéquates sur la menace.",
  "Resp-CS-02_desc":
    "Fournir des informations sur la catastrophe à la société, y compris la gestion des bénévoles et les appels.",
  "Resp-SF-01_desc":
    "Évacuation contrôlée des personnes et animaux d'une zone ou d'un bâtiment.",
  "Resp-SF-02_desc":
    "Hébergement des évacués, y compris nutrition et assainissement.",
  "Resp-SF-03_desc": "Réunification des évacués avec leurs proches.",
  "Resp-DA-01_desc": "Enlèvement des décombres et/ou matériaux contaminés.",
  "Resp-DA-02_desc":
    "Décontamination des zones, infrastructures et/ou véhicules contaminés.",
  "Resp-DA-03_desc":
    "Drainage et pompage des zones ou infrastructures inondées.",
  "Resp-DA-04_desc": "Destruction d'animaux potentiellement infectés.",
  "Resp-BN-01_desc": "Restauration ou fourniture temporaire d'eau potable.",
  "Resp-BN-02_desc": "Fourniture temporaire de nourriture.",
  "Resp-BN-03_desc":
    "Restauration de l'alimentation électrique/gaz ou fourniture d'énergie alternative temporaire.",
  "Resp-BN-04_desc":
    "Restauration ou fourniture temporaire de TIC et de télécommunications.",
  "Resp-BN-05_desc":
    "Restaurer l'assainissement ou fournir des solutions temporaires.",
  "Resp-RS-01_desc":
    "Prise de décision, planification et tasking aux niveaux de coordination et de commandement lors d'un événement catastrophique.",
  "Resp-RS-02_desc":
    "Développement d'informations opérationnelles par enrichissement des données collectées, y compris le tableau de bord opérationnel commun.",
  "Resp-RS-03_desc":
    "Stockage et partage d'informations telles que données collectées, évaluations et décisions prises.",
  "Resp-RS-04_desc":
    "Collecte de données par surveillance physique et exploration de données.",
  "Resp-RS-05_desc":
    "Fourniture de services de base aux premiers intervenants sur site pour permettre les activités de réponse.",
  "Resp-RS-06_desc":
    "Transport du personnel et du matériel pour soutenir les opérations prolongées de réponse aux catastrophes.",
  "Rec-HR-01_desc":
    "Fourniture de services de santé publique et de sécurité pour les personnes déplacées.",
  "Rec-HR-02_desc":
    "Fourniture de nourriture et d'hébergement pour les personnes déplacées.",
  "Rec-ER-01_desc":
    "Dépollution à grande échelle et décontamination, et traitement des déchets.",
  "Rec-ER-02_desc": "Restauration des ressources naturelles et des habitats.",
  "Rec-EC-01_desc":
    "Rétablissement des commerces et industries touchés par la catastrophe.",
  "Rec-EC-02_desc": "Rétablissement de l'impact financier sur les autorités.",
  "Rec-RI-01_desc":
    "Rétablissement des voies de transport (route, rail, eau, air, pipelines).",
  "Rec-RI-02_desc":
    "Restauration des services publics interrompus et autres services essentiels.",
  "Rec-RS-01_desc":
    "Établissement de la structure organisationnelle de rétablissement pour le court et long terme.",
  "Rec-RS-02_desc":
    "Détermination et mise en œuvre du programme de rétablissement basé sur l'évaluation des impacts.",
  manage_capabilities: "Sélectionner les capacités",
  select_capabilities_instr:
    "Sélectionnez les capacités que vous souhaitez évaluer pour les lacunes.",
  drawer_hazards: "Risques",
  drawer_gaps: "Lacunes",
  drawer_solutions: "Solutions",
  drawer_roadmap: "Feuille de route",
  drawer_capabilities: "Capacités",
  drawer_solution: "Solution",
  drawer_with_gaps: "avec lacunes",
  drawer_no_linked_caps: "Aucune capacité liée",
  drawer_add_to_roadmap: "Ajouter à la feuille de route →",
  drawer_go_to_solutions: "Aller aux solutions →",
  drawer_go_to_roadmap: "Aller à la feuille de route →",
  drawer_none: "Aucun",
  drawer_relevant_hazards: "Risques pertinents",
  action_priority: "Priorité d'action",
  action_priority_instr:
    "Évaluez votre volonté d'agir pour améliorer cette capacité (1 = faible, 5 = urgent)",
  action_priority_label_1: "Pas maintenant",
  action_priority_label_3: "Peut-être",
  action_priority_label_5: "Urgent",
  prev_cap: "Précédent",
  next_cap: "Suivant",
  about_markdown: `#### DIREKTION Assessment & Screening Framework (DASF)

L'ensemble d'outils DASF soutient le processus systématique d'évaluation et de dépistage pour la gestion des catastrophes. Il fournit une approche structurée en 4 étapes :

1. **Initiation et Préparation (I&P)** : Identifiez les types de dangers pertinents et définissez l'étendue de l'évaluation.
2. **Évaluation des Besoins et des Lacunes (EBL)** : Évaluez les capacités dans le cycle de gestion des catastrophes, identifiez les lacunes et les besoins d'amélioration.
3. **Évaluation des Solutions (ES)** : Évaluez les solutions potentielles pour les lacunes de capacité identifiées, y compris la conformité, les besoins des utilisateurs et l'évaluation des impacts.
4. **Feuille de Route (FR)** : Planifiez les calendriers de mise en œuvre et les engagements pour les solutions sélectionnées.

##### Débuter

- Créez ou ouvrez une session d'évaluation à partir de la page d'accueil
- Naviguez à travers les 4 étapes en utilisant les icônes de la barre d'outils
- Basculez entre les rôles Utilisateur et Éditeur à l'aide du sélecteur ci-dessous

##### Rôles

- **Utilisateur Standard** : Peut remplir les évaluations et afficher les résultats
- **Modérateur** : Peut modifier la configuration du cadre (types de dangers, capacités, parties prenantes)
- **Administrateur** : Peut modifier les échelles d'évaluation et les paramètres

##### Contexte

Ce projet a reçu un financement du programme de recherche et d'innovation Horizon 2020 de l'Union européenne. Développé par TNO dans le cadre du projet [DIREKTION](https://www.direktion-network.org).`,

  // ── Collaboration (EN fallback) ────────────────────────────────────────────
  COLLABORATE: {
    TITLE: "Collaborate",
    ROUTE: "/collaborate",
    PAGE: "Collaboration",
  },
  FACILITATOR: "Facilitator",
  collab_page_title: "Collaboration",
  collab_send_invite: "Send Invite",
  collab_load_patch: "Load Patch",
  collab_mode_ca: "Capability Assessment",
  collab_mode_sc: "Solution Creation",
  collab_mode_sa: "Solution Assessment",
  collab_select_modes: "Select collaboration modes",
  collab_your_name: "Your name",
  collab_your_email: "Your email",
  collab_facilitator_name: "Facilitator name",
  collab_facilitator_email: "Facilitator email",
  collab_custom_message: "Optional message",
  collab_generate_link: "Send Invite by Email",
  collab_done: "Termine - Envoyer les resultats",
  collab_patch_loaded: "Patch loaded",
  collab_patches_count: {
    1: "1 patch received",
    n: "{n} patches received",
  },
  collab_hash_mismatch:
    "Warning: This patch was created from a different version of the model.",
  collab_session_mismatch:
    "This patch belongs to a different session and cannot be loaded.",
  collab_duplicate_ignored: "Duplicate patch ignored (already loaded).",
  collab_aggregated_results: "Aggregated Results",
  collab_apply_results: "Apply to model",
  collab_no_patches: "No patches received yet.",
  collab_invited_by: "You have been invited by {name} ({email}) to contribute.",
  collab_paste_patch: "Paste a patch link here",
  collab_load_patch_btn: "Load",
  collab_remove_patch: "Remove",
  collab_contributor: "Contributor",
  collab_received_at: "Received at",
  collab_avg_action_priority: "Avg. action priority",
  collab_task_items: "Task importance answers",
  collab_perf_items: "Performance answers",
  collab_gap_items: "Gap answers",
  collab_all_values: "All values",
  collab_avg_value: "Average",
  collab_invite_subject: "Invitation to collaborate on capability assessment",
  collab_invite_body:
    "Dear colleague,\n\nYou are invited to contribute to a capability assessment for {facilitatorName}.\n\nPlease click the link below to open the assessment tool and fill in your responses. When you are done, click the 'Done' button to send your results back.\n\nThis link is valid for one-time use — please do not share it.\n\nKind regards,\n{facilitatorName}",
  collab_patch_subject: "Capability assessment completed",
  collab_patch_body:
    "Dear {facilitatorName},\n\nI have completed the capability assessment you sent me.\n\nPlease click the link below to load my responses into the tool.\n\nKind regards,\n{userName}",
  // ── End Collaboration ───────────────────────────────────────────────────────
};
